<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :isSearch="isSearch"
              :tableData="tableData"
              @add="addSwiper">
      <div slot="table">
        <swiper-table :tableData="tableData.list" @view="view" @del="del"></swiper-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import SwiperTable from "./SwiperTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getSwiperList,newVue,delBySwiperId} from "../../network/swiper";

  export default {
    name: "swiperList",
    components: {SwiperTable, MyTable},
    data(){
      return {
        title: "轮播商品列表",
        isAdd:true,
        isSearch: false,
        tableData:{
          list:[]
        }
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/swiper/list";
      this.common.HeaderLocationTwo.name =  "轮播图管理"
      this.common.HeaderLocationThree.name = "轮播图列表"
      getSwiperList().then(res => {
        this.tableData.list = res.data
        this.tableData.total = res.data.length
        this.tableData.totalPage = 1
        this.tableData.pageNum = 1
        this.tableData.pageSize = 10
        for (let i =0;i<this.tableData.list.length;i++){
          if (this.tableData.list[i].swiperType==0){
            this.tableData.list[i].swiperType='商品轮播'
          }else {
            this.tableData.list[i].swiperType='活动轮播'
          }
        }
      })

    },
    methods:{
      addSwiper(){
        this.$router.push("insert/")
      },
      view(id,swiperType){
        let pmsInfoId = null
        if (swiperType=="商品轮播"){
          for (let i = 0;i<this.tableData.list.length;i++){
            if (this.tableData.list[i].id==id){
              pmsInfoId = this.tableData.list[i].pmsSkuInfo.id
            }
          }
          this.$router.push("/pmsSkuInfo/data/"+pmsInfoId)
        }else {
          this.$router.push("insert/"+id)
        }
      },
      del(id){
        this.$confirm('此操作会将该商品从轮播中删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delBySwiperId(id).then(res => {
            getSwiperList().then(res => {
              this.tableData.list = res.data
              this.tableData.total = res.data.length
              this.tableData.totalPage = 1
              this.tableData.pageNum = 1
              this.tableData.pageSize = 10
              for (let i =0;i<this.tableData.list.length;i++){
                if (this.tableData.list[i].swiperType==0){
                  this.tableData.list[i].swiperType='商品轮播'
                }else {
                  this.tableData.list[i].swiperType='活动轮播'
                }
              }
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  }
</script>

<style scoped>

</style>
